export let Lang = {};

Lang.install = function(Vue, options) {
    let langs = JSON.parse(window.laravel.localeJSON);

    Vue.prototype.$lang = function(value) {
        return langs[value] ?? value;
	}
};
